import { render, staticRenderFns } from "./Layout2.vue?vue&type=template&id=5c0f5bc0"
import script from "./Layout2.vue?vue&type=script&lang=js"
export * from "./Layout2.vue?vue&type=script&lang=js"
import style0 from "./Layout2.vue?vue&type=style&index=0&id=5c0f5bc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports